var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 49,
    viewBox: "0 0 35 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 239221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 48,
    transform: "translate(0 0.954102)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 238576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M30.3334 22.1179C29.7284 21.6036 5.09881 4.54649 3.97535 3.86076L3.62976 3.60352V7.80348C3.62976 9.17493 4.32102 9.60351 5.18524 10.2892L5.35808 10.375C6.56797 11.2322 24.1112 23.3179 26.4445 24.9465C24.1112 26.5751 6.30867 38.8322 5.18524 39.518C3.8025 40.3751 3.71608 40.9751 3.71608 42.1751V46.2037C3.71608 46.2037 29.9013 28.118 30.4198 27.6894C31.6297 26.8322 31.889 25.7179 31.889 25.0322V24.5179C31.889 23.6608 31.3704 22.8036 30.3334 22.1179Z",
    fill: "#356AE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M14.9506 26.8321C15.6419 26.8321 16.3333 26.575 17.0247 26.0608C17.8889 25.4608 18.6666 24.9465 18.6666 24.9465L18.926 24.775L18.6666 24.6037C18.58 24.5178 7.08637 16.6322 5.87648 15.8608C5.35796 15.4322 4.6666 15.3465 4.23448 15.6036C3.80238 15.8608 3.45679 16.2893 3.45679 16.975V19.6322L3.54331 19.718C3.62986 19.8039 11.4939 25.2037 13.0494 26.2323C13.7408 26.6609 14.3456 26.8321 14.9506 26.8321Z",
    fill: "#356AE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCampaign);
export default __webpack_public_path__ + "static/media/active_campaign.8a529e5e979b457c7b98e1f426cdb454.svg";
export { ForwardRef as ReactComponent };